export function getTypes(key) {
  const ARTBOARD_TYPES = ['pages', 'components']
  // const COMPONENT_TYPES = ['components']
  // const PAGE_TYPES = ['pages']
  const STATE_TYPES = ['state']
  const ASSETS_TYPES = ['files']
  const FUNCTION_TYPES = ['functions', 'methods', 'snippets']
  const INTEGRATIONS_TYPES = ['dependencies', 'secrets']
  const COLOR_TYPES = [
    'color',
    'gradient',
    'semantic_color',
    'global_theme',
    'theme'
  ]
  const TYPOGRAPHY_TYPES = [
    'typography',
    'font',
    'font_family',
    'type_templates'
  ]
  const ICON_TYPES = ['icons']
  const SPACING_TYPES = ['spacing', 'shape']
  const RESPONSIVE_TYPES = ['media']
  const TRANSITION_TYPES = ['animations', 'transitions']
  const DESIGN_SYSTEM_TYPES = [
    ...COLOR_TYPES,
    ...TYPOGRAPHY_TYPES,
    ...ICON_TYPES,
    ...SPACING_TYPES,
    ...RESPONSIVE_TYPES,
    ...TRANSITION_TYPES
  ]

  const DATA_TYPES = [
    ...ARTBOARD_TYPES,
    ...STATE_TYPES,
    ...ASSETS_TYPES,
    ...FUNCTION_TYPES,
    ...INTEGRATIONS_TYPES
  ]

  const ALL_TYPES = [
    ...ARTBOARD_TYPES,
    ...STATE_TYPES,
    ...ASSETS_TYPES,
    ...FUNCTION_TYPES,
    ...INTEGRATIONS_TYPES,
    ...DESIGN_SYSTEM_TYPES
  ]

  const typeMap = {
    ALL_TYPES,
    DATA_TYPES,
    ARTBOARD_TYPES,
    STATE_TYPES,
    ASSETS_TYPES,
    FUNCTION_TYPES,
    INTEGRATIONS_TYPES,
    COLOR_TYPES,
    TYPOGRAPHY_TYPES,
    ICON_TYPES,
    SPACING_TYPES,
    RESPONSIVE_TYPES,
    TRANSITION_TYPES,
    DESIGN_SYSTEM_TYPES
  }

  return key ? typeMap[key] : typeMap
}

export function hasType(key, type) {
  const types = this.call('getTypes', key)
  return types.includes(type)
}
export function getWhichKey(type) {
  const typeMap = this.call('getTypes') // get the full map

  const keys = Object.keys(typeMap)

  // Skip ALL_TYPES since it's just an aggregate
  const filteredKeys = keys.filter((k) => k !== 'ALL_TYPES')

  const foundIn = filteredKeys.filter((key) => {
    const list = typeMap[key]
    return Array.isArray(list) && list.includes(type)
  })

  return foundIn
}

export function hasItems(type) {
  const hasData = this.getData(type)
  return Boolean(hasData && Object.keys(hasData).length > 0)
}

export function hasArtboard(type) {
  return this.call('hasType', 'ARTBOARD_TYPES', type)
}

export function hasExecutable(type) {
  return this.call('hasType', 'FUNCTION_TYPES', type)
}
